import { cssSpacing, viola } from "./../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Message = styled.span.withConfig({
  displayName: "Message",
  componentId: "sc-15vkh7g-0"
})(["", " padding-block-end:", ";padding-block-start:", ";flex:", ";"], viola(), cssSpacing('tighter-5', '2px'), cssSpacing('tighter-5', '2px'), function (props) {
  return props.align === 'center' ? undefined : 1;
});